import {Role} from '@/modules/core/data/roles';

const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_AUTH_USER_STORAGE));
const initialState = user
    ? {status: {loggedIn: true}, user, patches: {}, profile: {}}
    : {status: {loggedIn: false}, user: null, patches: {updated: false}, profile: {}};

export const auth = {
  namespaced: true,
  state: initialState,
  getters: {
    isLoggedIn: state => state.status.loggedIn,
    isAdmin: state => state.status.loggedIn && state.user.roles.includes(Role.Admin),
    isOperator: state => state.status.loggedIn && (state.user.roles.includes(Role.Admin) || state.user.roles.includes(Role.Operator)),
    isManager: state => state.status.loggedIn &&
        (state.user.roles.includes(Role.Operator) || state.user.roles.includes(Role.Manager)
          || state.user.roles.includes(Role.Admin)),
    isViewEmployee: state => state.status.loggedIn &&
      (state.user.roles.includes(Role.ViewEmployee) || state.user.roles.includes(Role.Admin)),
    isCustomerMaster: state => state.status.loggedIn &&
        (state.user.roles.includes(Role.Master) || state.user.roles.includes(Role.Admin)),
    isFacilityManager: state => state.status.loggedIn &&
      (state.user.roles.includes(Role.Admin) || state.user.roles.includes(Role.FacilityManager)),
    isMain: state => state.status.loggedIn && (state.user.roles.includes(Role.Admin) || state.user.main),
    isWorker: state => state.status.loggedIn && state.user.roles.includes(Role.Worker)
  },
  actions: {
    logout({commit}) {
      // reset user
      localStorage.removeItem(process.env.VUE_APP_AUTH_USER_STORAGE);
      // reset language
      localStorage.removeItem(process.env.VUE_APP_LANGUAGE_STORAGE);
      commit('clearStore');
      commit('logout');
    },
    clearStore({commit}){
      localStorage.removeItem(process.env.VUE_APP_AUTH_USER_STORAGE);
      commit('clearStore');
    }
  },
  mutations: {
    loginSuccess(state, keycloak) {
      state.status.loggedIn = true;
      state.user = {
        token: keycloak.token,
        refreshToken: keycloak.refreshToken,
        roles: keycloak.realmAccess.roles,
        main: keycloak.tokenParsed.mainUser
      };

      localStorage.setItem(process.env.VUE_APP_AUTH_USER_STORAGE, JSON.stringify(state.user));

      state.keycloak = keycloak;

      if(window.location.pathname === '/404' || window.location.pathname === '/403') {
        window.location.replace('/home')
      }
    },
    storeProfile(state, profile) {
      state.profile = profile;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.keycloak.logout();
      state.profile = {};
    },
    clearStore(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    setPatchPopup(state, patches) {
      state.patches = {data: patches, updated: true};
    }
  }
};
